<div class="header">
    <h2>{{ 'schools.modal.add.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="schools-add-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
    <div class="section">
        <h2>{{ 'schools.fieldset.basic' | translate }}</h2>
        <div class="row">
            <app-form-input
                [control]="form.controls.name"
                [label]="'schools.form.name' | translate"
                [placeholder]="'schools.form.name.placeholder' | translate"
                inputId="name"
                testId="schools-add-name"
            />
            <app-form-input
                [control]="form.controls.shortName"
                [label]="'schools.form.shortName' | translate"
                [placeholder]="'schools.form.shortName.placeholder' | translate"
                inputId="shortName"
                testId="schools-add-short-name"
            />
        </div>

        <app-form-textarea
            [control]="form.controls.description"
            [label]="'schools.form.description' | translate"
            [placeholder]="'schools.form.description.placeholder' | translate"
            inputId="description"
            testId="schools-add-description"
        />

        <app-form-input
            [control]="form.controls.rollNumber"
            [label]="'schools.form.rollNumber' | translate"
            [placeholder]="'schools.form.rollNumber.placeholder' | translate"
            inputId="rollNumber"
            testId="schools-add-roll-number"
        />
    </div>

    <div class="section">
        <h2>{{ 'schools.fieldset.contact' | translate }}</h2>
        <app-form-input
            [control]="form.controls.contactEmail"
            [label]="'schools.form.contactEmail' | translate"
            [placeholder]="'schools.form.contactEmail.placeholder' | translate"
            type="email"
            inputId="contactEmail"
            testId="schools-add-contact-email"
        />
    </div>

    <div class="section">
        <h2>{{ 'schools.fieldset.courses' | translate }}</h2>
        <app-form-multiselect
            [control]="form.controls.courseIds"
            [label]="'schools.form.courses' | translate"
            [placeholder]="'schools.form.courses.placeholder' | translate"
            [options]="courseOptions()"
            [filter]="true"
            inputId="courseIds"
            testId="schools-add-course-ids"
        />
    </div>

    <div class="section" formGroupName="address">
        <h2>{{ 'schools.fieldset.address' | translate }}</h2>
        <app-form-input
            [control]="form.controls.address.controls.street"
            [label]="'schools.form.street' | translate"
            [placeholder]="'schools.form.street.placeholder' | translate"
            inputId="street"
            testId="schools-add-street"
        />

        <div class="row">
            <app-form-input
                [control]="form.controls.address.controls.postalCode"
                [label]="'schools.form.postalCode' | translate"
                [placeholder]="'schools.form.postalCode.placeholder' | translate"
                inputId="postalCode"
                testId="schools-add-postal-code"
            />
            <app-form-input
                [control]="form.controls.address.controls.city"
                [label]="'schools.form.city' | translate"
                [placeholder]="'schools.form.city.placeholder' | translate"
                inputId="city"
                testId="schools-add-city"
            />
        </div>

        <app-form-select
            [control]="form.controls.address.controls.country"
            [label]="'schools.form.country' | translate"
            [placeholder]="'schools.form.country.placeholder' | translate"
            [options]="countryOptions"
            [filter]="true"
            inputId="country"
            testId="schools-add-country"
        />
    </div>
</form>

<div class="footer">
    <p-button [label]="'schools.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="schools-add-cancel" (onClick)="close()" />
    <p-button
        type="submit"
        [label]="'schools.form.create' | translate"
        [loading]="saving()"
        [disabled]="form.disabled"
        data-test="schools-add-submit"
        (onClick)="onSubmit()"
    />
</div>
